export default __webpack_public_path__ + "static/media/krist.46bd76d6.png";